import { type ReactNode } from 'react'
import { Icon, type IIconProps, Typography } from 'shared/ui'
import styles from './styles.module.scss'

type IDropdownButtonProps = {
  iconProps?: IIconProps
  text: string
  rightContent?: ReactNode
  onClick: () => void
}

export const FlowDropdownButton = ({
  text,
  iconProps,
  onClick,
  rightContent,
}: IDropdownButtonProps) => {
  return (
    <button className={styles.item} onClick={onClick}>
      {iconProps && <Icon {...iconProps} />}
      <Typography ariaLabel={text} variant={'body-md-regular'} className={styles.title}>
        {text}
      </Typography>
      {rightContent}
    </button>
  )
}
